import { atom, useAtom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { useEffect, useMemo } from 'react';
export const issuesInCurrentSessionIdsFamily = atomFamily(_pageId => atom(null));
export const sessionElementsFamily = atomFamily(_pageId => atom(new Map()));
export const useGetColorContrastElementsInSession = _ref => {
  let {
    pageId,
    failedElements,
    passedElements
  } = _ref;
  const [issuesInCurrentSessionIds, setIssuesInCurrentSessionIds] = useAtom(issuesInCurrentSessionIdsFamily(pageId));
  const [sessionElements, setSessionElements] = useAtom(sessionElementsFamily(pageId));
  useEffect(() => {
    if (issuesInCurrentSessionIds === null) {
      setIssuesInCurrentSessionIds(failedElements.map(_ref2 => {
        let {
          uiElementId
        } = _ref2;
        return uiElementId;
      }));
    } else {
      const newFailedElements = failedElements.filter(_ref3 => {
        let {
          uiElementId
        } = _ref3;
        return !issuesInCurrentSessionIds.includes(uiElementId);
      });
      if (newFailedElements.length) {
        setIssuesInCurrentSessionIds([...issuesInCurrentSessionIds, ...newFailedElements.map(_ref4 => {
          let {
            uiElementId
          } = _ref4;
          return uiElementId;
        })]);
      }
    }
  }, [failedElements, issuesInCurrentSessionIds, setIssuesInCurrentSessionIds]);
  useEffect(() => {
    const updatedMap = new Map(sessionElements);
    let hasChanges = false;
    failedElements.forEach(element => {
      const key = element.uiElementId;
      const currentElement = updatedMap.get(key);
      if (!currentElement || currentElement.isValid !== element.isValid) {
        updatedMap.set(key, element);
        hasChanges = true;
      }
    });
    passedElements.forEach(element => {
      const key = element.uiElementId;
      const currentElement = updatedMap.get(key);
      const updatedElement = {
        ...element,
        isValid: true
      };
      if (!currentElement || currentElement.isValid !== updatedElement.isValid) {
        updatedMap.set(key, updatedElement);
        hasChanges = true;
      }
    });
    if (hasChanges) {
      setSessionElements(updatedMap);
    }
  }, [failedElements, passedElements, sessionElements, setSessionElements]);
  const {
    elements,
    completedSize
  } = useMemo(() => {
    const fixedGenericElements = [];
    if (issuesInCurrentSessionIds != null && issuesInCurrentSessionIds.length) {
      issuesInCurrentSessionIds.forEach(id => {
        const isInFailed = failedElements.some(el => el.uiElementId === id);
        const isInPassed = passedElements.some(el => el.uiElementId === id);
        if (!isInFailed && !isInPassed) {
          const element = sessionElements.get(id);
          if (element) {
            fixedGenericElements.push({
              ...element,
              isValid: true
            });
          }
        }
      });
    }
    const allPassedElements = [...passedElements, ...fixedGenericElements];
    const idToIndexMap = new Map();
    issuesInCurrentSessionIds == null || issuesInCurrentSessionIds.forEach((id, index) => {
      idToIndexMap.set(id, index);
    });
    const sortedElements = [...failedElements, ...allPassedElements].sort((a, b) => {
      const indexA = idToIndexMap.get(a.uiElementId);
      const indexB = idToIndexMap.get(b.uiElementId);
      if (indexA === undefined) {
        return 1;
      }
      if (indexB === undefined) {
        return -1;
      }
      return indexA - indexB;
    });
    return {
      completedSize: allPassedElements.length,
      elements: sortedElements
    };
  }, [failedElements, passedElements, issuesInCurrentSessionIds, sessionElements]);
  return {
    completedSize,
    elements
  };
};
//# sourceMappingURL=use-get-color-contrast-elements-in-session.js.map